import { useState, useEffect } from 'react'
import { appFetchDurationAPI } from '../services/duration'
import { useTranslation } from 'react-i18next'

export default function UseLeaveDuration() {
  const { t } = useTranslation()
  const [data, setData] = useState(null)
  useEffect(() => {
    const getTranslation = async () => {
      const result = await appFetchDurationAPI()
      if (!result) return
      const data = JSON.parse(
        result?.appFetchRemoteConfigByKey?.payload?.value ?? '[]',
      )

      const formatData = data.map((d) => ({
        value: d.value,
        label: t(d.label),
      }))
      setData(formatData)
    }
    getTranslation()
  }, [t])

  return data
}
